export const WARNING_TYPES = Object.freeze({
    PENDING_APPROVAL:   'pending_approval',
    PAGE_NOT_FOUND:     'page_not_found',
    LOGIN_REQUIRED:     'login_required',
    SUBSCRIBE_REQUIRED: 'subscribe_required',
})

export const hasWarning = (item, type) =>
    Array.isArray(item?.warnings) && item.warnings.some(w => w?._type === type)

export const getWarning = (item, type) =>
    Array.isArray(item?.warnings) ? item.warnings.find(w => w?._type === type) : null

export const isPendingApproval = (item) =>
    item?.pending_approval === true || hasWarning(item, WARNING_TYPES.PENDING_APPROVAL)

export const isPageNotFound    = (item) => hasWarning(item, WARNING_TYPES.PAGE_NOT_FOUND)
export const isLoginRequired   = (item) => hasWarning(item, WARNING_TYPES.LOGIN_REQUIRED)
export const isSubscribeRequired = (item) => hasWarning(item, WARNING_TYPES.SUBSCRIBE_REQUIRED)
